import {
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
} from '@/ux-common/components/tooltip/tooltip';

/**
 * The one tooltip bubble every left-nav trigger shares: portalled so the
 * branch-env frame cannot skew its placement, centred to the right of the
 * rail, with the arrow painted from the bubble's own background token.
 */
export const NavTooltipContent = ({ label }: { label: string }) => (
  <TooltipPortal>
    <TooltipContent align={'center'} side={'right'}>
      <span className={'text-xs'}>{label}</span>
      <TooltipArrow />
    </TooltipContent>
  </TooltipPortal>
);
